module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isLogined) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "checkoutContent",
    attrs: {
      "element-loading-text": _vm.elementLoadingText
    }
  }, [_c('div', {
    staticClass: "deliveryInfo"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("确认收货信息")]), _vm._v(" "), _c('div', {
    staticClass: "deliveryContent"
  }, [_c('div', {
    staticClass: "head"
  }, [_vm._v("收货信息")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.isAddAddress) ? _c('div', {
    staticClass: "saveDeliveryAddress"
  }, [_c('div', {
    staticClass: "addressInfo"
  }, [_c('div', {
    staticClass: "deliveryInfo1"
  }, [_vm._m(0), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg.name),
      expression: "msg.name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入收货人"
    },
    domProps: {
      "value": (_vm.msg.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.msg, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(1), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg.mobile),
      expression: "msg.mobile"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号码"
    },
    domProps: {
      "value": (_vm.msg.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.msg, "mobile", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "deliveryInfo2"
  }, [_vm._m(2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg.province),
      expression: "msg.province"
    }],
    attrs: {
      "placeholder": "请选择省份"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.msg, "province", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.changeProvince(_vm.msg.province)
      }]
    }
  }, _vm._l((_vm.provinces), function(item) {
    return _c('option', {
      key: item.value,
      attrs: {
        "label": item.name
      },
      domProps: {
        "value": item.name
      }
    })
  }), 0), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg.city),
      expression: "msg.city"
    }],
    attrs: {
      "placeholder": "请选择城市"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.msg, "city", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.changeCity(_vm.msg.city)
      }]
    }
  }, _vm._l((_vm.cities), function(item) {
    return _c('option', {
      key: item.value,
      attrs: {
        "label": item.name
      },
      domProps: {
        "value": item.name
      }
    })
  }), 0), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg.area),
      expression: "msg.area"
    }],
    attrs: {
      "placeholder": "请选择县/区"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.msg, "area", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.areas), function(item) {
    return _c('option', {
      key: item.value,
      attrs: {
        "label": item.name
      },
      domProps: {
        "value": item.name
      }
    })
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "deliveryInfo3"
  }, [_vm._m(3), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.msg.address),
      expression: "msg.address"
    }],
    attrs: {
      "rows": "2",
      "placeholder": "请输入详细地址"
    },
    domProps: {
      "value": (_vm.msg.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.msg, "address", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('div', {
    staticClass: "deliveryDefault"
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.msg.isDefault),
      callback: function($$v) {
        _vm.$set(_vm.msg, "isDefault", $$v)
      },
      expression: "msg.isDefault"
    }
  }, [_vm._v("设置默认收货地址")])], 1), _vm._v(" "), _c('div', {
    staticClass: "deliverySaveBtn"
  }, [_c('input', {
    attrs: {
      "type": "button",
      "value": "保存地址"
    },
    on: {
      "click": _vm.save
    }
  }), _c('input', {
    staticClass: "cancelBtn",
    attrs: {
      "type": "button",
      "value": "取消"
    },
    on: {
      "click": _vm.cancelSave
    }
  })])])]) : _c('div', {
    staticClass: "deliveryAddressList"
  }, [_c('table', [_vm._m(4), _vm._v(" "), _vm._l((_vm.addList), function(item, i) {
    return _c('tr', {
      key: i
    }, [_c('td', [_c('el-checkbox', {
      key: 'select_' + item.id,
      on: {
        "change": function($event) {
          return _vm.selectAddress(item.id)
        }
      },
      model: {
        value: (item.checked),
        callback: function($$v) {
          _vm.$set(item, "checked", $$v)
        },
        expression: "item.checked"
      }
    })], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.province) + _vm._s(item.city) + _vm._s(item.area))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.address))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.mobile))]), _vm._v(" "), _c('td', [(item.isDefault) ? _c('input', {
      staticClass: "DefaultAddress",
      attrs: {
        "type": "button",
        "value": "默认地址"
      }
    }) : _c('input', {
      staticClass: "DefaultAddress1",
      attrs: {
        "type": "button",
        "value": "设置默认"
      },
      on: {
        "click": function($event) {
          return _vm.changeDef(item)
        }
      }
    })])])
  })], 2), _vm._v(" "), (_vm.addList.length == 0) ? _c('img', {
    staticClass: "notHaveDeliveryAddress",
    attrs: {
      "src": "http://img.static.knnnj.com/Default/dcb7cc98-a007-4f37-88cc-539fdaf24747.png"
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    staticClass: "addDeliveryAddress",
    attrs: {
      "type": "button",
      "value": "添加新地址"
    },
    on: {
      "click": _vm.addAddress
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "helpFundInfo"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("订单帮扶")]), _vm._v(" "), _c('div', {
    staticClass: "helpFundContent"
  }, [_c('div', {
    staticClass: "head"
  }, [_vm._v("订单帮扶金："), _c('span', [_vm._v(_vm._s(Number(_vm.totalHelpFund).toFixed(2)))]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "选择帮扶人员"
    },
    on: {
      "click": _vm._selectVeteran
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.veteran && _vm.veteran.veteranId > 0) ? _c('div', {
    staticClass: "veteranPhoto"
  }, [_c('img', {
    staticClass: "photo",
    attrs: {
      "src": _vm.veteran.photo
    }
  }), _vm._v(" "), (_vm.veteran.sex == 0 || _vm.veteran.sex == false) ? _c('img', {
    staticClass: "sex",
    attrs: {
      "src": "https://file-sz.fjjykj.com.cn/Supply/s6e13598728334b924712b04a842b4eef.png"
    }
  }) : _c('img', {
    staticClass: "sex",
    attrs: {
      "src": "https://file-sz.fjjykj.com.cn/Supply/sd2ffec0974c7f31c402e31a89c6e4d8b.png"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.veteran && _vm.veteran.veteranId > 0) ? _c('div', {
    staticClass: "veteranName"
  }, [_vm._v(_vm._s(_vm.veteran.veteranName)), _c('span', [_vm._v(_vm._s(_vm.veteran.age) + "岁")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "orderInfo"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("确认订单信息")]), _vm._v(" "), _c('div', {
    staticClass: "orderContent"
  }, [_c('table', [_vm._m(5), _vm._v(" "), _vm._l((_vm.cartList), function(item, i) {
    return _c('tr', {
      key: 'product_' + item.postFee + i
    }, [_c('td', {
      staticClass: "productImage"
    }, [_c('img', {
      attrs: {
        "src": item.defaultImage
      },
      on: {
        "click": function($event) {
          return _vm.goodsDetails(item.productId)
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name) + "(" + _vm._s(item.specName) + ")")]), _vm._v(" "), _c('td', [_vm._v("￥" + _vm._s(Number(item.settlementPrice).toFixed(2)))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.num),
        expression: "item.num"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (item.num)
      },
      on: {
        "change": _vm.countPostFee,
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "num", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "productListAmount"
    }, [_vm._v("￥" + _vm._s(Number(item.settlementPrice * item.num).toFixed(2)))]), _vm._v(" "), _c('td', {
      staticClass: "productListAmount"
    }, [_vm._v("￥" + _vm._s(Number(item.postFee).toFixed(2)))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "sellerRemarks"
  }, [_c('div', [_vm._v("给卖家留言：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remarks),
      expression: "remarks"
    }],
    attrs: {
      "type": "text",
      "placeholder": "给卖家留言"
    },
    domProps: {
      "value": (_vm.remarks)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.remarks = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "orderfooter"
  }, [_c('input', {
    attrs: {
      "type": "button",
      "value": "去付款"
    },
    on: {
      "click": _vm._submitOrder
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "orderAmount"
  }, [_vm._v("￥" + _vm._s(Number(_vm.checkPrice).toFixed(2)))]), _vm._v(" "), _c('div', {
    staticClass: "payLabel"
  }, [_vm._v("应付总额：")])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])]), _vm._v(" "), _c('selectVeteran', {
    ref: "selectVeteran",
    on: {
      "seted": _vm._getVeteran
    }
  })], 1) : _c('div', {
    staticClass: "checkoutContent1"
  }, [_c('div', {
    on: {
      "click": function($event) {
        return _vm.toLogin()
      }
    }
  }, [_vm._v("亲,请先登陆")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', [_vm._v("*")]), _vm._v("收货人：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', [_vm._v("*")]), _vm._v("手机号码：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', [_vm._v("*")]), _vm._v("所在地区：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', [_vm._v("*")]), _vm._v("详细地址：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "addressHead"
  }, [_c('th', {
    staticClass: "selectAddress"
  }), _vm._v(" "), _c('th', {
    staticClass: "deliveryName"
  }, [_vm._v("收货人")]), _vm._v(" "), _c('th', {
    staticClass: "location"
  }, [_vm._v("所在地区")]), _vm._v(" "), _c('th', {
    staticClass: "address"
  }, [_vm._v("详细地址")]), _vm._v(" "), _c('th', {
    staticClass: "mobile"
  }, [_vm._v("手机")]), _vm._v(" "), _c('th', {
    staticClass: "operate"
  }, [_vm._v("操作")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "productHead"
  }, [_c('th', {
    staticClass: "productName",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("商品信息")]), _vm._v(" "), _c('th', {
    staticClass: "productPrice"
  }, [_vm._v("单价")]), _vm._v(" "), _c('th', {
    staticClass: "productNum"
  }, [_vm._v("数量")]), _vm._v(" "), _c('th', {
    staticClass: "productTotal"
  }, [_vm._v("总价")]), _vm._v(" "), _c('th', {
    staticClass: "productPostFee"
  }, [_vm._v("运费")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e8dc3b3","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/checkout/index.vue
// module id = 758
// module chunks = 2